import React, { useEffect, useRef } from "react";
import { CenterSpinner, useAuth, useLogin } from "@soap/modules";
import { getPostLogoutReturnUrl } from "../constants/postLogoutReturnUrl";

/**
 * Public route `#/logout`: shows a spinner and calls `useLogin().logOut(returnTo)` so
 * Auth0 end-session runs after protected shells unmount. See postLogoutReturnUrl.js.
 */
export function LogoutPage() {
    const maintenance = window.LYW?.maintenance === true;
    const { authReady, authEnabled, isAuthenticated } = useAuth("logout-page");
    const { logOut } = useLogin();
    const started = useRef(false);

    useEffect(() => {
        if (maintenance) return;
        if (!authReady || !authEnabled) return;
        // SOAP `isAuthenticated` is null while not ready; only treat explicit false as "already logged out"
        if (isAuthenticated !== true) {
            if (isAuthenticated === false && !started.current) {
                window.location.replace(getPostLogoutReturnUrl());
            }
            return;
        }
        if (started.current) return;
        started.current = true;
        logOut(getPostLogoutReturnUrl());
    }, [authReady, authEnabled, isAuthenticated, maintenance, logOut]);

    if (maintenance) {
        return (
            <div
                style={{
                    minHeight: "40vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Lato, sans-serif",
                    color: "#656565",
                    padding: "2rem",
                    textAlign: "center",
                }}
            >
                Sign-out is temporarily unavailable while we perform maintenance.
            </div>
        );
    }

    return (
        <div
            style={{
                minHeight: "50vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
            }}
        >
            <CenterSpinner />
            <p style={{ fontFamily: "Lato, sans-serif", color: "#656565", fontSize: "15px" }}>
                Signing out…
            </p>
        </div>
    );
}
